module.exports = __webpack_public_path__ + "img/example-security-measures-arrows.fa291299.webp";